import { createContext } from "react";

type PhoneInputContextValue = {
  countryDescribedBy: string;
  numberDescribedBy: string;
  groupWidth: number;
  startSlot: string | undefined;
  setStartSlot: (startSlot: string) => void;
};

const PhoneInputContext = createContext<PhoneInputContextValue>(
  {} as PhoneInputContextValue
);

export default PhoneInputContext;
